import React from "react";

function SlideThrough() {
  return (
    <>
      <iframe src="https://webbyscroller.netlify.app/" allow="full"></iframe>
    </>
  );
}

export default SlideThrough;
